import { ArrowUp, ArrowDown } from 'lucide-react';

function KpiTile({ icon: Icon, label, value, sub, delta, deltaDir, onClick }) {
  return (
    <div className="kpi" style={{ cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
      <div className="head">
        <div className="kpi-icon"><Icon size={20} /></div>
        <div className="lbl">{label}</div>
      </div>
      <div>
        <div className="v">{value}</div>
        {sub && <div className="sub">{sub}</div>}
        {delta && (
          <div className={`delta${deltaDir === 'down' ? ' down' : ''}`}>
            {deltaDir === 'down'
              ? <ArrowDown size={12} />
              : <ArrowUp size={12} />}
            <span style={{ marginLeft: 4 }}>{delta}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default KpiTile;
